import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "saddle-selection" }
const _hoisted_2 = { class: "saddle-selection__filters" }
const _hoisted_3 = { class: "saddle-selection__content" }
const _hoisted_4 = { class: "saddle-selection__buttons" }

import { ref } from 'vue'
import { ButtonState, ButtonType, BfButton } from '@finetic/bikefitting-ui'
import { useRouter } from 'vue-router'
import { useSaddleStore } from '@/store/saddleStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useI18n } from 'vue-i18n'
import SaddleFilters from '@/components/setup/saddle/SaddleFilters.vue'
import SaddleSelection from '@/components/setup/saddle/SaddleSelection.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SaddleSelectionView',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const saddleStore = useSaddleStore()
const measurementStore = useMeasurementStore()
const selected = ref()

saddleStore.reset()

const select = (saddle: any) => {
  selected.value = saddle
}

const cancel = () => {
  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

const install = () => {
  if (measurementStore.selectedMeasurement) {
    measurementStore.selectedMeasurement.saddle.active = selected.value
  }

  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SaddleFilters)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", null, _toDisplayString(_unref(t)('setup.saddle.selection')), 1),
      _createVNode(SaddleSelection, { onSelect: select }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(BfButton), {
          type: _unref(ButtonType).Outlined,
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_unref(BfButton), {
          state: selected.value ? _unref(ButtonState).Enabled : _unref(ButtonState).Disabled,
          onClick: install
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.install')), 1)
          ]),
          _: 1
        }, 8, ["state"])
      ])
    ])
  ]))
}
}

})